/* eslint-disable max-len */
import React, { useContext, useState } from 'react'
import BannerImage from '../../../components/BannerImage'
import SignIn from './Components/SignIn'
import GlobalContext from '../../../components/Context/GloablContext';
import { useDispatch } from 'react-redux';
import { logIn } from '../authSlice';
import OtpPage from './Components/Otp';
import { handleClear } from '../../../redux/commonSlice';
import { useNavigate, useLocation } from 'react-router-dom';
import ForgotPassword from './Components/ForgotPassword';
import SetPreferencesModal from './Components/SetPreferencesModal';
import { userService } from '../../../services/user.services';
import { handleRestrictKey } from '../../../redux/systemConfigSlice';
import refreshIdToken from '../../../CommonMethods/RefreshIdFunction';
import MaskedEmailJS from '../../../CommonMethods/MaskedEmailJS'
import TrustBrowser from './Components/TrustBrowser';
import DuplicateTabCloseModal from './Components/DuplicateTabCloseModal';
import authenticateUser from '../../../config/aws-export';
import { GlobalWorkerOptions } from 'pdfjs-dist/build/pdf';
import localStorage from 'redux-persist/lib/storage';
import { persistAuthSession, stageAuthSession, clearAuthSession, setAuthItem, getAuthItem, broadcastLogin } from '../../../CommonMethods/authSession';
GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;

export default function LoginPage() {
    const { setToastmessage, setToastErrorMessage, setIsSideBar, WebSocketConnection, fetchAndCacheHelpGuides } = useContext(GlobalContext)
    const [IsLoginPage, setIsLoginPage] = useState(true);
    const [loading, setloading] = useState(false);
    const [isForgotPassword, setIsForgotPassword] = useState(false);
    const [otp, setOtp] = useState("000000");
    const [duration, setDuration] = useState('')


    const [displayOtpScreen, setDisplayOtpScreen] = useState(false)
    const dispactch = useDispatch()
    const [loginCredentials, setloginCredentials] = useState({
        email: '',
        password: ''
    });
    const [error, seterror] = useState(false);
    const [emptyError, setEmptyError] = useState(false)
    const navigate = useNavigate()
    const location = useLocation()
    
    const getRedirectPath = (defaultPath) => {
        if (location.state?.from) {
            return location.state.from.pathname + (location.state.from.search || '');
        }
        const params = new URLSearchParams(location.search);
        const redirect = params.get('redirect');
        return redirect ? decodeURIComponent(redirect) : defaultPath;
    };

    const [preferenceModel, setPreferenceModel] = useState(false);
    const [preferenceList, setPreferenceList] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [preferenceLoading, setPreferenceLoading] = useState(false);
    const [selectedPreference, setSelectedPreference] = useState([]);
    const [isTrustMyBrowser, setIsTrustMyBrowser] = useState(false)

    const [isSubmitSelected, setIsSubmitSelected] = useState(false)
    const [loginError, setloginError] = useState('')
    const { email, password } = loginCredentials

    const [duplicateTabModal, setDuplicateTabModal] = useState(false);
    const [dupLoadingBtn, setDupLoadingBtn] = useState(false);
    const [loginData, setLoginData] = useState('')

    const handleLoginCredentilas = (key, value) => {
        if (key === "email") {
            setloginCredentials((current) => ({
                ...current,
                [key]: value.replace(/\s/g, '')
            }))

        } else {
            setloginCredentials((current) => ({
                ...current,
                [key]: value
            }))
        }
    }

    const handleRefreshToken = async () => {
        if (getAuthItem('IdToken')) {
            refreshIdToken()
        }
    };

    const handleLogin = async (e, key) => {
        setIsSubmitSelected(true)
        seterror(false)
        e.preventDefault();
        if (key === undefined) {
            setloading(true);
            setOtp(Array(6).fill(""))
        }

        if (email?.trim().replace(/\s/g, '') === "" || password?.trim() === "") {
            setEmptyError(true)
            setToastErrorMessage("Please fill in all the mandatory fields")
            setloading(false)
            return
        }
        setAuthItem('email', email);
        let browser_id = await localStorage.getItem('arcm_trust_browser_token') || '';
        try {
            const loginresponse = await userService.login(email.toLowerCase().trim().replace(/\s/g, ''), password, browser_id);
            setLoginData(loginresponse);

            // Store user-info directly to sessionStorage BEFORE isLoggedIn check.
            // Ensures Sidebar has username even during duplicate session modal flow.
            // Only store if first_name is present (avoid overwriting with empty data).
            if (loginresponse?.data?.first_name) {
                sessionStorage.setItem('user-info', JSON.stringify({
                    first_name: loginresponse?.data?.first_name,
                    middle_name: loginresponse?.data?.last_name,
                }));
            }

            if (loginresponse?.data?.isLoggedIn && loginresponse?.data?.isLoggedIn === true) {

                stageAuthSession({
                    email,
                    IdToken: loginresponse?.data?.IdToken,
                    RefreshToken: loginresponse?.data?.RefreshToken,
                    AccessToken: loginresponse?.data?.AccessToken,
                    user_id: loginresponse?.data?.user_id,
                    id: loginresponse?.data?.id,
                    user_type: loginresponse?.data?.user_type,
                    session_token: loginresponse.data.session_token,
                });
                setPreferenceList(loginresponse?.data?.Preference_list)

                if (loginresponse?.data?.restrict !== null) {
                    dispactch(handleRestrictKey(loginresponse?.data?.restrict))
                    setIsSideBar(loginresponse?.data?.restrict)
                }

                setloading(false)
                setDuplicateTabModal(true)

                return
            }

            if (loginresponse?.data?.Preference_list && loginresponse.data?.Preference_list?.length > 0) {
                setPreferenceModel(true)
                persistAuthSession({
                    session_token: loginresponse.data.session_token,
                    user_type: loginresponse?.data?.user_access_type,
                });
                setPreferenceList(loginresponse.data.Preference_list)
                setloading(false);
                return

            } else {
                if (loginresponse.error) {
                    seterror(true);
                    setloginError(loginresponse.message.response.data.message)
                    setloading(false);
                } else {
                    persistAuthSession({
                        email,
                        IdToken: loginresponse?.data?.IdToken,
                        RefreshToken: loginresponse?.data?.RefreshToken,
                        AccessToken: loginresponse?.data?.AccessToken,
                        user_id: loginresponse?.data?.user_id,
                        id: loginresponse?.data?.id,
                        user_type: loginresponse?.data?.user_type,
                        ...(loginresponse?.data?.first_name && {
                            'user-info': {
                                first_name: loginresponse?.data?.first_name,
                                middle_name: loginresponse?.data?.last_name,
                            }
                        }),
                    });

                    if ((loginresponse?.data?.restrict === false && loginresponse?.data?.trust_my_browser === true) || loginresponse?.data?.restrict === false || loginresponse?.data?.status === 'success') {
                        dispactch(handleRestrictKey(false))
                        setIsSideBar(false)
                        dispactch(logIn());
                        refreshIdToken()
                        authenticateUser(email.toLowerCase().trim().replace(/\s/g, ''), password)
                        setInterval(handleRefreshToken, 9 * 60 * 1000);
                        setToastmessage('Login successful')
                        WebSocketConnection()
                        broadcastLogin()
                        setTimeout(function () {
                            // dispactch(handleSidebarAnimation(false))
                            const defaultPath = loginresponse?.data?.user_type === 'super-admin' ? '/system-configuration' : '/profile';
                            const redirectPath = getRedirectPath(defaultPath);
                            navigate(redirectPath)
                        }, 500);
                        if(localStorage.getItem('arcm_trust_browser_token') !== null){
                            fetchAndCacheHelpGuides()
                        }
                        return
                    }
                    if (loginresponse?.data?.restrict === "true" || loginresponse?.data?.restrict === true) {
                        setIsSideBar(loginresponse?.data?.restrict)
                        dispactch(handleRestrictKey(loginresponse?.data?.restrict))
                        dispactch(logIn());
                        setToastmessage('Login successful')
                        WebSocketConnection()
                        refreshIdToken()
                        setInterval(handleRefreshToken, 9 * 60 * 1000);
                        const redirectPath = getRedirectPath('/profile');
                        navigate(redirectPath)
                        if(localStorage.getItem('arcm_trust_browser_token') !== null){
                            fetchAndCacheHelpGuides()
                        }
                        return
                    }
                    if (loginresponse.data.is_reset_password === false || loginresponse.data.status === 'reset') {

                        setAuthItem('custom:is_first_time_login', true);
                        setToastmessage('Login successful')
                        refreshIdToken()
                        const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);
                        // Preserve the deep-link redirect so ResetPassword can restore it after logout
                        navigate('/reset-password', { state: { 'refresh_interval': intervalId, redirect: getRedirectPath(null) } })
                        return
                    }
                    // setToastmessage('You’ve received an OTP to your registered email address or +91 xxxx-xxxxx')
                    setIsLoginPage(false);
                    setDisplayOtpScreen(true);
                    setloading(false);
                }
            }


        } catch (error) {
            if (error.code === "NotAuthorizedException") {
                setloginError(error.message)
            }
            else {
                setloginError(error.message?.split("error")[1])
            }

            seterror(true);
            setloading(false);

        }
    };
    const handelClear = () => {
        setloginCredentials({
            email: '',
            password: ''
        });
        setloginError('')
        seterror(false)
    }


    const handleSelectPreference = async (item) => {
        setSelectedPreference(item)
    }

    const handleSendotptoPreference = async () => {
        setPreferenceLoading(true)
        const response = await userService.sendOtptoPreference(selectedPreference._id);
        if (response.error === false) {
            persistAuthSession({
                verify_otp_session_token: response.data.verify_otp_session_token,
            });
            setDuration(response.data.otp_resend_duration);
            persistAuthSession({
                preference_id: selectedPreference._id,
            });
            setToastmessage(`You’ve been sent an OTP to ${selectedPreference.otp_preference_mode === 'email'
                ? MaskedEmailJS(selectedPreference.preference)
                : `${selectedPreference?.country_code} ${selectedPreference?.preference?.slice(0, 2) +
                '*'.repeat(selectedPreference?.preference?.length - 4) +
                selectedPreference?.preference?.slice(-2)}`
                }`)
            setDisplayOtpScreen(true)
            setIsLoginPage(false)
            setPreferenceLoading(false)
            setPreferenceModel(false)
        } else {
            setPreferenceLoading(false)
            setToastErrorMessage(response.message)
            // setDisplayOtpScreen(true)
            // setPreferenceModel(false)
        }
    }

    const handleClose = () => {
        setPreferenceModel(false)
        setIsDropdownOpen(false)
        setSelectedPreference([])
    }

    // Duplicate tab closing fun below

    const handleAllowDuplicateTabClose = async () => {

        if (loginData?.data?.Preference_list === undefined && loginData?.data?.isLoggedIn === true) {
            setDupLoadingBtn(true)

            const sessionUpdatePayload = {
                email,
                IdToken: loginData?.data?.IdToken,
                RefreshToken: loginData?.data?.RefreshToken,
                AccessToken: loginData?.data?.AccessToken,
                user_id: loginData?.data?.user_id,
                id: loginData?.data?.id,
                user_type: loginData?.data?.user_access_type,
            };

            // Only include user-info if response has name data.
            // Avoid overwriting the previously correct value stored at line 119.
            if (loginData?.data?.first_name) {
                sessionUpdatePayload['user-info'] = {
                    first_name: loginData?.data?.first_name,
                    middle_name: loginData?.data?.last_name,
                };
            }

            persistAuthSession(sessionUpdatePayload);

            await userService.DuplicateTabClose('');

            setDuplicateTabModal(false);
            dispactch(logIn());
            refreshIdToken()
            setInterval(handleRefreshToken, 9 * 60 * 1000);
            WebSocketConnection()
            broadcastLogin()
            const redirectPath = getRedirectPath('/profile');
            navigate(redirectPath);
        }
        else {
            sessionStorage.removeItem('duplicate_session_pending');
            setDuplicateTabModal(false)
            setPreferenceModel(true)
        }
    }

    const handleDuplicateModalClose = async () => {
        setPreferenceModel(false)
        setDuplicateTabModal(false)
        clearAuthSession()
        await userService.CancelDuplicatelogin('')
    }

    return (
        <>
            <div className='flex bg-white'>
                {!isTrustMyBrowser && <BannerImage />}
                {!isForgotPassword && IsLoginPage && !displayOtpScreen && !isTrustMyBrowser && <SignIn
                    isSubmitSelected={isSubmitSelected}
                    setIsSubmitSelected={setIsSubmitSelected}
                    setIsLoginPage={setIsLoginPage}
                    email={email}
                    emptyError={emptyError}
                    setEmptyError={setEmptyError}
                    handleLoginCredentilas={handleLoginCredentilas}
                    error={error}
                    loginError={loginError}
                    seterror={seterror}
                    password={password}
                    loading={loading}
                    setIsForgotPassword={setIsForgotPassword}
                    handleLogin={handleLogin}
                />}
                {duplicateTabModal &&
                    <DuplicateTabCloseModal
                        tittle={'Duplicate Session?'}
                        buttonName={'Yes'}
                        message={'You are already logged in through another system. Do you want to end the other session and login here?'}
                        handleAllowDuplicateClose={handleAllowDuplicateTabClose}
                        handleClose={handleDuplicateModalClose}
                        dupLoadingBtn={dupLoadingBtn}
                        data_testid={"continue-btn"}
                    />
                }
                {/* {!isForgotPassword  && IsLoginPage && !displayOtpScreen&& <ResetPassword
                />} */}
                {/* {!isForgotPassword  && !IsLoginPage &&userData.signInUserSession===null&& <p><OtpPage/></p>} */}
                {displayOtpScreen && <OtpPage
                    selectedPreference={selectedPreference}
                    setSelectedPreference={setSelectedPreference}
                    setloginCredentials={setloginCredentials}
                    setIsLoginPage={setIsLoginPage}
                    handleLogin={handleLogin}
                    duration={duration}
                    setIsTrustMyBrowser={setIsTrustMyBrowser}
                    setOtp={setOtp}
                    otp={otp}
                    setIsForgotPassword={setIsForgotPassword}
                    displayOtpScreen={displayOtpScreen}
                    handelClear={handleClear}
                    setPreferenceModel={setPreferenceModel}
                    setDisplayOtpScreen={setDisplayOtpScreen}
                    loginCredentials={loginCredentials}
                    loginData={loginData}
                />}
                {/* {!isForgotPassword&&!IsLoginPage&& idToken!=="" && <SideBar/>} */}
                {isForgotPassword && IsLoginPage &&
                    <ForgotPassword
                        setIsForgotPassword={setIsForgotPassword}
                        handelClear={handelClear}
                        useremail={email}
                        emptyError={emptyError}
                        setEmptyError={setEmptyError}
                        error={error}
                        loginError={loginError}
                        seterror={seterror}
                        loading={loading}
                        setloading={setloading}
                    />}

                {preferenceModel &&
                    <SetPreferencesModal
                        tittle={'Verify your Identity'}
                        buttonName={'Send'}
                        message={'Select your preference to receive the verification code'}
                        preferenceList={preferenceList}
                        isDropdownOpen={isDropdownOpen}
                        setIsDropdownOpen={setIsDropdownOpen}
                        handleSelectPreference={handleSelectPreference}
                        handleSendotptoPreference={handleSendotptoPreference}
                        selectedPreference={selectedPreference}
                        handleClose={handleClose}
                        setPreferenceLoading={setPreferenceLoading}
                        preferenceLoading={preferenceLoading}
                    />
                }
                {
                    isTrustMyBrowser &&
                    <TrustBrowser
                        setIsTrustMyBrowser={setIsTrustMyBrowser} />
                }

            </div>
        </>
    )
}
